import styled from "styled-components";

export const PageWrapper = styled.div`
  margin-bottom: 10px;
`;
